import React from 'react';
import { Container, Typography, Grid, Card, CardContent } from '@mui/material';

const differences = [
  { title: 'Sustainability', description: 'Eco-friendly sourcing and production.' },
  { title: 'Quality Assurance', description: 'Strict quality checks at every stage.' },
  { title: 'Customer Focus', description: 'Tailored solutions for every client.' },
];

const DifferencePage = () => (
  <Container sx={{ py: 6 }}>
    <Typography variant="h3" gutterBottom align="center">
      What Sets Us Apart
    </Typography>
    <Grid container spacing={4} justifyContent="center">
      {differences.map((diff) => (
        <Grid item xs={12} md={4} key={diff.title}>
          <Card sx={{ minHeight: 180 }}>
            <CardContent>
              <Typography variant="h5" gutterBottom>{diff.title}</Typography>
              <Typography variant="body2">{diff.description}</Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  </Container>
);

export default DifferencePage; 